var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoplesicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 6.8C3.6 5.52696 4.10571 4.30606 5.00589 3.40589C5.90606 2.50571 7.12696 2 8.4 2C9.67304 2 10.8939 2.50571 11.7941 3.40589C12.6943 4.30606 13.2 5.52696 13.2 6.8C13.2 8.07304 12.6943 9.29394 11.7941 10.1941C10.8939 11.0943 9.67304 11.6 8.4 11.6C7.12696 11.6 5.90606 11.0943 5.00589 10.1941C4.10571 9.29394 3.6 8.07304 3.6 6.8ZM0 20.0863C0 16.3925 2.9925 13.4 6.68625 13.4H10.1138C13.8075 13.4 16.8 16.3925 16.8 20.0863C16.8 20.7013 16.3013 21.2 15.6862 21.2H1.11375C0.49875 21.2 0 20.7013 0 20.0863ZM22.8488 21.2H17.6775C17.88 20.8475 18 20.4387 18 20V19.7C18 17.4238 16.9838 15.38 15.3825 14.0075C15.4725 14.0038 15.5588 14 15.6488 14H17.9513C21.2925 14 24 16.7075 24 20.0487C24 20.6863 23.4825 21.2 22.8488 21.2ZM16.2 11.6C15.0375 11.6 13.9875 11.1275 13.2263 10.3663C13.965 9.36875 14.4 8.135 14.4 6.8C14.4 5.795 14.1525 4.84625 13.7138 4.01375C14.4113 3.50375 15.27 3.2 16.2 3.2C18.5213 3.2 20.4 5.07875 20.4 7.4C20.4 9.72125 18.5213 11.6 16.2 11.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplesicon);
export default __webpack_public_path__ + "static/media/peoples.icon.ed718cd8169874763e809d6dad36c7bf.svg";
export { ForwardRef as ReactComponent };